import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { t } from '@cwos/ui-shared';
import styles from './right-now.module.css';
function greetingKey(hour) {
    if (hour < 12)
        return 'greeting.morning';
    if (hour < 18)
        return 'greeting.afternoon';
    return 'greeting.evening';
}
export function HeroGreeting({ name, sentence, needsKnown, now = new Date() }) {
    const greeting = t(greetingKey(now.getHours()));
    // A sentence the caller composed is always shown: it was composed from
    // something. Only the ABSENCE of one is ambiguous, and that is what
    // `needsKnown` disambiguates.
    const line = sentence ??
        (needsKnown
            ? t('greeting.nothingNeedsYou')
            : 'We couldn’t check what needs you just now — this is not an all-clear.');
    return (_jsxs("section", { className: styles.hero, "aria-label": "Greeting", children: [_jsxs("h1", { className: styles.heroTitle, children: [greeting, ", ", name] }), _jsx("p", { className: styles.heroSentence, children: line })] }));
}
//# sourceMappingURL=HeroGreeting.js.map